import React, {Component} from "react";

export default class ErrorSpan extends Component {
    render() {
        return (
            <span className="invalid-feedback d-block">
                <strong>{this.props.error}</strong>
            </span>
        )
    }
}
